// extracted by mini-css-extract-plugin
export var actions = "_ti-4";
export var item = "_ti-1";
export var price = "_ti-3";
export var quantity = "_ti-2";
export var table = "_ti-0";